/**
 * Monotonic turn counter and the last turn that reached an outcome.
 *
 * A deadline is only half the guarantee. `failTurn` aborts the SSE stream, but
 * abort is not instantaneous — the reader can already be mid-iteration, and a
 * `progress` / `chunk` / keep-alive that lands after we gave up would call
 * `setProgress` / `setIsTyping(true)` and re-arm the silence watchdogs, putting
 * the reasoning indicator back on screen with no deadline left to stop it. The
 * spinner would be immortal again through a different door.
 *
 * So every turn carries an epoch, every non-terminal callback checks it, and a
 * settled turn ignores everything that arrives late. This also stops a previous
 * turn's straggler from bleeding into the turn that replaced it.
 */
let turnEpoch = 0
let settledTurnEpoch = 0

export function beginTurn(): number {
  turnEpoch += 1
  return turnEpoch
}

/** Mark the current turn as concluded — nothing that arrives later may revive it. */
export function settleCurrentTurn(): void {
  settledTurnEpoch = turnEpoch
}

export function turnIsSettled(epoch: number): boolean {
  return epoch <= settledTurnEpoch
}

export function isCurrentTurn(epoch: number): boolean {
  return epoch === turnEpoch
}
